import { Box } from '@mui/material';
import { Notification } from 'iconsax-react';
import type { FC } from 'react';

import { hasStringValue, hasValue } from '@core/utils/equality';
import type {
  NotificationScope,
  NotificationScopeObject,
  NotificationTab,
} from '@core/utils/notifications';

import { EmptyState } from '../EmptyState/EmptyState';

type EmptyStateText = {
  title: string;
  description: string;
};

const NO_RESULTS_TEXT: EmptyStateText = {
  title: 'No Results Found',
  description: 'Try adjusting your search or filters',
};

export type NotificationEmptyStateOpts = {
  search: string;
  scope: NotificationScope;
  scopeObject: NotificationScopeObject | null;
};

export const hasActiveFilters = ({
  search,
  scope,
  scopeObject,
}: NotificationEmptyStateOpts): boolean =>
  hasStringValue(search) || (scope === 'currentObject' && hasValue(scopeObject));

export const notificationEmptyStateText = (
  tab: NotificationTab,
  opts: NotificationEmptyStateOpts,
): EmptyStateText => {
  if (hasActiveFilters(opts)) return NO_RESULTS_TEXT;

  return tab === 'unread'
    ? {
        title: 'No Unread Notifications',
        description: 'You are all caught up',
      }
    : {
        title: 'No Notifications Yet',
        description: 'Notifications will show up here when something needs your attention',
      };
};

export const reminderEmptyStateText = (opts: NotificationEmptyStateOpts): EmptyStateText =>
  hasActiveFilters(opts)
    ? NO_RESULTS_TEXT
    : {
        title: 'No Reminders Yet',
        description: 'Set up reminders to get notified when something needs your attention',
      };

type Props = {
  title: string;
  description: string;
};

export const NotificationCenterEmptyState: FC<Props> = ({ title, description }) => (
  <Box
    sx={{
      marginX: 2,
      marginTop: 2.5,
    }}
  >
    <EmptyState bgVariant='gray' icon={Notification} title={title} description={description} />
  </Box>
);
